export default "__VITE_ASSET__BaMbtG$e__"